"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const Box_1 = __importDefault(require("@mui/material/Box"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const actions_1 = require("companion-app-components/flux/preferences/actions");
const selectors_1 = require("companion-app-components/flux/preferences/selectors");
const QSwitch_1 = __importDefault(require("components/QSwitch"));
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const investments_quicken_inline_svg_1 = __importDefault(require("assets/nav-menu/investments.quicken.inline.svg"));
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const Investments = () => {
    const { classes } = useStyles();
    const dispatch = (0, react_redux_1.useDispatch)();
    const isV2QuotesEnabled = (0, react_redux_1.useSelector)(selectors_1.isRealTimeQuotesEnabled);
    const [realTimeQuotesEnabled, setRealTimeQuotesEnabled] = (0, react_1.useState)(Boolean(isV2QuotesEnabled));
    (0, react_1.useEffect)(() => {
        setRealTimeQuotesEnabled(Boolean(isV2QuotesEnabled));
    }, [isV2QuotesEnabled]);
    const onPrefChange = (event) => {
        dispatch((0, actions_1.setPreference)({
            section: 'shared',
            group: 'dataset',
            preference: { datasetOptions: { useRealtimeQuotes: event.target.checked } },
        }));
    };
    return (<>
      <Box_1.default marginBottom={3}>
        <Typography_1.default id={'investments_page_header'} variant="h5" className={classes.headlineText}>
          <investments_quicken_inline_svg_1.default className={classes.headlineIcon}/>
          <span>Investments</span>
        </Typography_1.default>
      </Box_1.default>
      <RendersCount_1.default id="investments-tab"/>
      <div className={classes.personalDetails}>
        <Box_1.default marginBottom={2} position="relative">
          <div className={classes.contentRow}>
            <Typography_1.default variant="subtitle2">
              Display Real-Time Quotes
            </Typography_1.default>
            <FormControlLabel_1.default checked={realTimeQuotesEnabled} labelPlacement="start" control={<QSwitch_1.default id="is-recurring-toggle" color="primary"/>} label="" onChange={onPrefChange}/>
          </div>
          <Typography_1.default variant="caption">
            With real-time quotes, pre-market quotes will display when available
          </Typography_1.default>
        </Box_1.default>
      </div>
    </>);
};
exports.default = Investments;
